// src/App.js - Super Admin Dashboard

import React, { useState, useEffect } from 'react';
import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate 
} from 'react-router-dom';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

import LoginPage from './LoginPage';
import SuperAdminDashboard from './SuperAdminDashboard';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // التحقق من أن المستخدم هو Super Admin
        try {
          const superAdminQuery = query(
            collection(db, 'super_admins'),
            where('auth_uid', '==', user.uid)
          );
          
          const snapshot = await getDocs(superAdminQuery);
          
          if (!snapshot.empty) {
            // المستخدم هو Super Admin ✅
            setSuperAdminData(snapshot.docs[0].data());
            setCurrentUser(user);
            setError('');
          } else {
            // المستخدم ليس Super Admin ❌
            setError('ليس لديك صلاحيات للوصول لهذه اللوحة');
            await auth.signOut();
            setCurrentUser(null);
            setSuperAdminData(null);
          }
        } catch (err) {
          console.error("Error checking super admin status:", err);
          setError('حدث خطأ أثناء التحقق من الصلاحيات');
          await auth.signOut();
          setCurrentUser(null);
          setSuperAdminData(null);
        }
      } else {
        setCurrentUser(null);
        setSuperAdminData(null);
        setError('');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Protected Route
  const ProtectedRoute = ({ children }) => {
    if (loading) {
      return (
        <div style={styles.loadingContainer}>
          جاري التحقق من الصلاحيات...
        </div>
      );
    }

    if (!currentUser || !superAdminData) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        جاري التحميل...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* صفحة تسجيل الدخول */}
        <Route 
          path="/" 
          element={
            !currentUser ? (
              <>
                {error && (
                  <div style={styles.errorBanner}>
                    {error}
                  </div>
                )}
                <LoginPage />
              </>
            ) : (
              <Navigate to="/dashboard" replace />
            )
          } 
        />

        {/* لوحة التحكم */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <SuperAdminDashboard 
                user={currentUser} 
                superAdminData={superAdminData} 
              />
            </ProtectedRoute>
          } 
        />

        {/* أي رابط غير موجود */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

const styles = {
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontSize: '24px',
    color: '#8be9fd',
    backgroundColor: '#1e1e2f',
  },
  errorBanner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    padding: '15px',
    backgroundColor: '#ff5555',
    color: 'white',
    textAlign: 'center',
    fontWeight: 'bold',
    zIndex: 9999,
  },
};

export default App;
